import { v4 as uuid } from 'uuid'
import type { I18nTranslate } from '@lib/types/common'
import type { AgendaItem } from '@agenda-selector/types/agenda.type'

export const generateNewAgenda = (t: I18nTranslate) => ({
  name: t('canvasUI.agendaSelector.defaultNewAgenda'),
  groups: [generateNewEmptyGroup(t)],
})

export const generateNewEmptyGroup = (t: I18nTranslate) => ({
  id: uuid(),
  name: t('canvasUI.agendaSelector.defaultNewGroupName'),
  items: [],
})

export const generateNewGroup = (name: string, items: AgendaItem[] = []) => ({
  id: uuid(),
  name,
  items,
})
